import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bed75b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-wrapper" }

import { ref } from 'vue'

import { Input } from '@/popup/components/shared/Form/Form'
import { passwordValidator } from '@/popup/components/shared/Form/validators'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import {
  InputError,
  InputValidator,
} from '@/popup/components/shared/Form/FormTypes'

type Props = {
  name?: string
  password?: string
  errors?: InputError[]
  showInfo?: boolean
  autofocus?: boolean
  validators?: InputValidator[]
  isBordered?: boolean
  hideErrors?: boolean
  autocomplete?: string
}

type Emits = {
  (event: 'update:password', value: string): void
  (event: 'update:errors', newErrors: InputError[]): void
  (event: 'on-blur'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Password',
  props: {
    name: { default: undefined },
    password: { default: '' },
    errors: { default: undefined },
    showInfo: { type: Boolean, default: true },
    autofocus: { type: Boolean, default: false },
    validators: { default: () => [passwordValidator] },
    isBordered: { type: Boolean, default: false },
    hideErrors: { type: Boolean, default: false },
    autocomplete: { default: undefined }
  },
  emits: ["update:password", "update:errors", "on-blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const input = ref(props.password)
const showPassword = ref(false)
const errors = ref<InputError[]>(props.errors ?? [])

const switchVisibility = () => (showPassword.value = !showPassword.value)

const onUpdate = (value: string) => {
  input.value = value
  emits('update:password', input.value)
}

const onErrors = (newErrors: InputError[]) => {
  errors.value = newErrors
  emits('update:errors', newErrors)
}

const onBlur = () => {
  emits('on-blur')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Input), {
      name: _ctx.name || 'password',
      value: input.value,
      type: showPassword.value ? 'text' : 'password',
      errors: errors.value,
      validators: _ctx.validators,
      autofocus: _ctx.autofocus,
      autocomplete: _ctx.autocomplete,
      "is-bordered": _ctx.isBordered,
      size: "large",
      "extra-classes": `input text-input ${_ctx.hideErrors ? 'hide-errors' : ''}`,
      onOnUpdate: onUpdate,
      onOnErrors: onErrors,
      onOnBlur: onBlur
    }, {
      default: _withCtx(() => [
        (showPassword.value)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              name: "eye-show",
              class: "show-password-icon",
              height: "24",
              width: "24",
              "data-testid": "password-eye-icon",
              onClick: switchVisibility
            }))
          : (_openBlock(), _createBlock(SvgIcon, {
              key: 1,
              name: "eye-hide",
              class: "show-password-icon",
              height: "24",
              width: "24",
              "data-testid": "password-eye-icon",
              onClick: switchVisibility
            }))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["name", "value", "type", "errors", "validators", "autofocus", "autocomplete", "is-bordered", "extra-classes"])
  ]))
}
}

})